module.exports = __webpack_public_path__ + "assets/img/10.3f861c54.jpg";